import React, {useState, useEffect} from 'react'
import './reports.css'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import profile from '../../../assets/profile.png'
import {getAllReports} from '../../../api/reportApi'
import { useDispatch, useSelector } from 'react-redux'
import {handleAddAllReport} from '../../../state/reportSlice'
import LinearProgress from '@mui/material/LinearProgress';


const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (param)=>{
            return (
                <div className='todolist__table-profile'>
                    <img src={!param?.row?.user?.profilePic ? profile
                    : `https://backend.aspomportal.com/upload/${param?.row?.user?.profilePic}`} 
                    alt={param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName}
                    className="todolist__table-img" />
                    <div className="todolist__table-profile_list">
                        <h4 className="todolist__table-profile_name">
                            {param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName}
                        </h4>
                        <span className="todolist__table-profile_email">
                        {param?.row?.department}{ ' ' }{param?.row?.role}
                        </span>
                    </div>
                </div>
            )
        }
    },
    {
        field: 'staffId',
        headerName: 'Employee ID',
        width: 150,
        renderCell: (param)=>(
            <span>
                {param?.row?.user?.staffId}
            </span>
        )
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 140,
        renderCell: (param)=>(
            <span>
                {param?.row?.user?.department}
            </span>
        )
    },
    {
        field: 'missed',
        headerName: 'Missed',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalMissed}
            </span>
        )
    },
    {
        field: 'submitted',
        headerName: 'Submitted',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalReportSubmitted}
            </span>
        )
    },
    {
        field: 'holiday',
        headerName: 'Holidays',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalHolidays}
            </span>
        )
    },
    {
        field: 'working-days',
        headerName: 'Working Days',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalWorkingDays}
            </span>
        )
    },
];


const StaffReports = () => {
    const {user} = useSelector((state)=>state.user)
    const {allReports} = useSelector((state)=>state.report)
    const dispatch = useDispatch()
    const [selectedMonth, setSelectedMonth] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleAllTasks = async ()=>{
        setIsLoading(true)
        try{
            const month = selectedMonth || getCurrentMonth()
            const res = await getAllReports(user?.token, month)
            dispatch(handleAddAllReport(res?.data))
            setIsLoading(false)
        }catch(error){
            setIsLoading(false)
            console.log(error)
        }
    }

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    const getCurrentMonth = () => {
        const date = new Date();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add padding to ensure two digits
        return month;
    };


    useEffect(()=>{
        handleAllTasks()
    },[selectedMonth])

  return (
    <section className='staff__reports'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Employee Reports | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        End of the Day Reports <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    Employee End of the Day Reports for {moment().format('MMMM YYYY')}
                </p>
            </div>
        </div>

        <div className="staff__reports__container">

            <div className="staff__reports__items">
                <div className="staff__reports__search">
                    <h4 className="staff__reports__search-title">
                        Reports for {moment().format('MMMM YYYY')}
                    </h4>
                    <div className="staff__reports__search-box">
                        <span className="staff__reports__search-span">Search:</span>
                        <select id="month" value={selectedMonth} 
                        onChange={handleMonthChange}
                        className="report__search-input">
                            <option value="">-- Select Month --</option>
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>
                    </div>
                </div>
                {isLoading && <LinearProgress sx={{width: '100%'}}/>}
                <div className="staff__reports__table">
                    <DataGrid
                        // getRowId={(rows => rows?.user?._id)}
                        rows={allReports?.map((item, i)=>({
                            id: i + 1,
                            ...item
                        })) ?? []}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 5,
                            },
                        },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        getRowHeight={() => 'auto'} 
                        sx={{
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                                py: 0.5,
                            },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                                py: '5px',
                            },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                                py: '10px',
                            },
                        }}
                        experimentalFeatures={{ lazyLoading: true }}
                    />
                </div>
            </div>
        </div>
    </section>
  )
}

export default StaffReports